import { allowedEmail } from '@/common/allowed.emails.js';
import { debounceAsync } from '@dsee/util/async.js';
import { checkEmail } from '@/restapi/user/user.js';
import { email, helpers } from '@vuelidate/validators';
import { maxLengthRule } from './main.js';

export function emailRulesDefault() {
    return {
        email: helpers.withMessage('Введите адрес почты в формате test@test.ru', email),
        ...maxLengthRule(),
    };
}

export function allowedEmailRule() {
    const validator = helpers.withAsync(debounceAsync(allowedEmail, 300));

    return {
        allowedEmail: helpers.withMessage('Указан неразрешенный почтовый домен', validator),
    };
}

export function duplicatedEmailRule() {
    const validator = helpers.withAsync(debounceAsync(async (value = '') => {
        if (typeof value !== 'string')
            return false;

        value = value.trim();

        if (!value)
            return true;

        try {
            return await checkEmail({
                email: value,
            });
        } catch (e) {
            console.warn(e);
            return false;
        }

    }, 300))

    return {
        duplicatedEmail: helpers.withMessage('Пользователь с указанным email уже существует', validator),
    };
}
